import { render, staticRenderFns } from "./headerProfile.vue?vue&type=template&id=504c0b0f&scoped=true&"
import script from "./headerProfile.vue?vue&type=script&lang=js&"
export * from "./headerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504c0b0f",
  null
  
)

export default component.exports